import xss from "xss";
import md5 from "md5";

import CONFIG from "../config";
import { getImageTypeBySignature, getSignatureFromBase64Data } from "../utils/functions/image";

const sortFooterByColumn = (a, b) => {
  return (!isNaN(a.columnorder) ? Number(a.columnorder) : 999) - (!isNaN(b.columnorder) ? Number(b.columnorder) : 999);
};

const sortFooterByRow = (a, b) => {
  return (!isNaN(a.roworder) ? Number(a.roworder) : 999) - (!isNaN(b.roworder) ? Number(b.roworder) : 999);
};

const mapFooterRow = (r, idx) => {
  return {
    rowname: xss(r.rowname),
    roworder: idx,
    rowurl: xss(r.rowurl)
  };
};

const mapFooterList = (f, idx) => {
  // sanitize footers
  return {
    columnname: xss(f.columnname),
    columnorder: idx,
    rows: Array.isArray(f.rows) ? f.rows.sort(sortFooterByRow).map(mapFooterRow) : []
  };
};

const mapFileList = (f) => {
  // sanitize files
  return {
    fileId: Number(f.fileId),
    fileOrder: Number(f.fileOrder) || 999,
    filename: xss(f.filename),
    url: xss(f.url)
  };
};

const sortFileList = (a, b) => {
  if (a.fileOrder !== b.fileOrder) return a.fileOrder < b.fileOrder ? -1 : 1;
  return a.fileId < b.fileId ? -1 : 1;
};

export default {
  header: {
    headertitle: "",
    headerLink: "",
    headerlogo1: "",
    headerlogo2: "",
    headerlogo3: "",
    headeralt1: "",
    headeralt2: "",
    headeralt3: "",
    headerbankname1: "",
    headerbankname2: "",
  },

  contactDetails: {
    telefon: "",
    mail: "",
    rueckruf: "",
    terminLink: "",
    chat: "",
    bildschirmteilen: "",
    kontaktdaten: "",
    mailTitle: "",
    rueckrufTitle: "",
    terminLinkTitle: "",
    chatTitle: "",
    bildschirmteilenTitle: "",
    kontaktdatenTitle: "",
    kontaktImage: CONFIG.DEFAULT_KONTAKT_IMAGE,
  },

  files: {},

  footer: {
    mandantFooterList: [],
  },

  sonstigeEinstellungen: {
    lieferadresseKz: "",
    yesVerifiedAdresseKz: "",
    schwellenwert: 0,
    minOrderValueFiliale: 0,
    searchLieferadresseAktiv: "",
    ablieferadresseAnkauf: "",
    searchAblieferadresseAktiv: "",
    abwAdresseBsErlaubt: "",
  },

  id: "",
  gpNummer: "",
  issuerUrl: "",
  hash: "",
  logo: null,
  orderLimit: null,

  sonstigeSeitenverweise: {},

  konditionenSet: [],

  setMandantData(data) {
    this.setMandant(data);
    this.setMandantHeader(data);
    this.setMandantFooter(data);
    this.setMandantKontakt(data);
    this.setMandantTheme(data);
    this.setMandantSonstigeLinks(data);
    this.setSonstigeEinstellungen(data);
    this.setMandantFileList(data);
    this.setKonditionenSet(data);
  },

  setMandantHeader(data) {
    if (!data || !data.mandant) return;
    this.header = {
      headertitle: xss(data.mandant.headertitle),
      headerLink: xss(data.mandant.headerLink),
      headerlogo1: xss(data.mandant.headerlogo1),
      headeralt1: xss(data.mandant.headeralt1),
    };
    let logo = [
      xss(data.mandant.headerlogo1),
      xss(data.mandant.headerlogo2),
      xss(data.mandant.headerlogo3),
      xss(data.mandant.logo)]
      .filter(l => !!l)
      .map(b64 => {
        try {
          if (b64.trim().match(/\.(jpeg|jpg|png|gif)$/i)) {
            return b64.trim();
          }
          const signature = getSignatureFromBase64Data(b64);
          const mimeType = getImageTypeBySignature(signature);
          if (mimeType.match(/^image/)) {
            return "data:" + mimeType + ";base64," + b64;
          }
        } catch (e) {
          console.log(e);
        }
        return null;
      })
      .filter(img => !!img);
    if (logo.length) this.logo = logo[0];
  },

  setMandantFooter(data) {
    if (!data || !data.mandant) return;
    if (!Array.isArray(data.mandant.mandantFooterList)) data.mandant.mandantFooterList = [];
    this.footer = {
      mandantFooterList: data.mandant.mandantFooterList.sort(sortFooterByColumn).map(mapFooterList).filter(f => !!f)
    };
  },

  setMandantFileList(data) {
    if (!data || !data.mandant) return;
    if (!Array.isArray(data.mandant.fileList)) data.mandant.fileList = [];
    this.files = {
      fileList: data.mandant.fileList.map(mapFileList).filter(f => !!f).sort(sortFileList)
    };
  },

  setMandantKontakt(data) {
    if (!data || !data.mandant) return;
    this.contactDetails = {
      telefon: xss(data.mandant.telefon),
      mail: xss(data.mandant.mail),
      rueckruf: xss(data.mandant.rueckruf),
      terminLink: xss(data.mandant.terminLink),
      chat: xss(data.mandant.chat),
      bildschirmteilen: xss(data.mandant.bildschirmteilen),
      kontaktdaten: xss(data.mandant.kontaktdaten),
      mailTitle: xss(data.mandant.mailTitle),
      rueckrufTitle: xss(data.mandant.rueckrufTitle),
      terminLinkTitle: xss(data.mandant.terminLinkTitle),
      chatTitle: xss(data.mandant.chatTitle),
      bildschirmteilenTitle: xss(data.mandant.bildschirmteilenTitle),
      kontaktdatenTitle: xss(data.mandant.kontaktdatenTitle),
      kontaktImage: CONFIG.DEFAULT_KONTAKT_IMAGE
    };
  },

  setMandant(data) {
    if (!data || !data.mandant) return;
    this.id = Number(data.mandant.id || data.id);
    this.hash = String(md5(process.env.REACT_APP_HASH_ID + "=" + this.id)).slice(0, 8);
    this.gpNummer = xss(data.mandant.gpNummer).trim();
    this.issuerUrl = xss(data.mandant.issuerUrl);
    const allowedValues = ["J", "N"];
    this.emKonditionenKz = allowedValues.includes(data.mandant.emKonditionenKz) ? data.mandant.emKonditionenKz : "N";
    this.soKonditionenKz = allowedValues.includes(data.mandant.soKonditionenKz) ? data.mandant.soKonditionenKz : "N";
  },

  setMandantTheme(data) {
    if (!data || !data.mandant) return;
    this.theme = xss(data.mandant.theme) || 'default';
    localStorage.setItem("theme", this.theme);
  },

  setMandantLogoImage(img) {
    this.logo = img;
  },

  setOrderLimit(data) {
    if (!data) return;
    this.orderLimit = data;
  },

  getOrderLimit() {
    return this.orderLimit;    
  },

  setSonstigeEinstellungen(data) {
    if (!data || !data.mandant) return;
    const allowedValues = ["J", "N"];
    this.sonstigeEinstellungen = {
      lieferadresseKz: allowedValues.includes(data.mandant.lieferadresseKz)
        ? data.mandant.lieferadresseKz
        : this.sonstigeEinstellungen.lieferadresseKz,
      yesVerifiedAdresseKz: allowedValues.includes(data.mandant.yesVerifiedAdresseKz)
        ? data.mandant.yesVerifiedAdresseKz
        : this.sonstigeEinstellungen.yesVerifiedAdresseKz,
      schwellenwert: isNaN(data.mandant.schwellenwert) ? 0 : Number(data.mandant.schwellenwert),
      minOrderValueFiliale: isNaN(data.mandant.minOrderValueFiliale) ? 0 : Number(data.mandant.minOrderValueFiliale),
      searchLieferadresseAktiv: allowedValues.includes(data.mandant.searchLieferadresseAktiv)
        ? data.mandant.searchLieferadresseAktiv
        : this.sonstigeEinstellungen.searchLieferadresseAktiv,
      ablieferadresseAnkauf: allowedValues.includes(data.mandant.ablieferadresseAnkauf)
        ? data.mandant.ablieferadresseAnkauf
        : this.sonstigeEinstellungen.ablieferadresseAnkauf,
      searchAblieferadresseAktiv: allowedValues.includes(data.mandant.searchAblieferadresseAktiv)
        ? data.mandant.searchAblieferadresseAktiv
        : this.sonstigeEinstellungen.searchAblieferadresseAktiv,
      abwAdresseBsErlaubt: allowedValues.includes(data.mandant.abwAdresseBsErlaubt)
        ? data.mandant.abwAdresseBsErlaubt
        : this.sonstigeEinstellungen.abwAdresseBsErlaubt,
    };
  },

  lieferadresseIsEditable() {
    return this.sonstigeEinstellungen && String(this.sonstigeEinstellungen.lieferadresseKz).toUpperCase() !== "N";
  },

  searchLieferadresseAktiv() {
    return this.sonstigeEinstellungen && String(this.sonstigeEinstellungen.searchLieferadresseAktiv).toUpperCase() === "J";
  },

  ablieferadresseAnkauf() {
    return this.sonstigeEinstellungen && String(this.sonstigeEinstellungen.ablieferadresseAnkauf).toUpperCase() === "J";
  },

  searchAblieferadresseAktiv() {
    return this.sonstigeEinstellungen && String(this.sonstigeEinstellungen.searchAblieferadresseAktiv).toUpperCase() === "J";
  },

  abwAdresseBsErlaubt() {
    return this.sonstigeEinstellungen && String(this.sonstigeEinstellungen.abwAdresseBsErlaubt).toUpperCase() !== "N";
  },

  getMinOrdervalueFiliale() {
    return this.sonstigeEinstellungen.minOrderValueFiliale;
  },

  deubaConfigActive() {
    return ( this.theme === 'deutschebank' || this.theme === 'postbank');
  },

  setMandantSonstigeLinks(data) {
    if (!data || !data.mandant) return;
    this.sonstigeLinks = {
      agb: xss(data.mandant.agb),
      sammelPostkorb: xss(data.mandant.sammelPostkorb),
      vviLink: xss(data.mandant.vviLink),
      absenderMailAdresse: xss(data.mandant.absenderMailAdresse)
    };
  },

  setKonditionenSet(data) {
    if (!data || !data.mandant) return;
    this.konditionenSet = [];
    if (String(data.mandant.emKonditionenKz).toUpperCase() === 'J') this.konditionenSet.push("edelmetall");
    if (String(data.mandant.soKonditionenKz).toUpperCase() === 'J') this.konditionenSet.push("sorten");
  },

  isBLBAdmin() {
    console.info("isBLBAdmin:", this.id === 1);
    return this.id === 1;
  },

  hasKonditionen() {
    return this.konditionenSet.length > 0;
  },

  hasEdelmetall() {
    return this.konditionenSet.includes("edelmetall");
  },

  hasSorten() {
    //return true; // für tests
    // eslint-disable-next-line
    return this.konditionenSet.includes("sorten");
  },

  isSparkasseThemeActive() {
    return this.theme === 'sparkasse';
  }
};
